import { Link } from 'react-router';
import { EmptyState } from '@/lib/ui';

export function ForbiddenPage() {
  return (
    <EmptyState
      title="You do not have access to this page"
      body="This area is limited to administrators. If you believe this is a mistake, contact an administrator."
      action={<Link className="btn btn-primary" to="/">Back to dashboard</Link>}
    />
  );
}
